import { SPICY_TAGS_MAP } from '../../constants/constants';

export const getSpicyInitialState = () => {
  return Object.values(SPICY_TAGS_MAP).reduce((acc, spicyLevel) => {
    acc[spicyLevel] = {
      name: '',
      remark: '',
      thumbnail: '',
    };
    return acc;
  }, {});
};
